// Save scenario as a split button (TX-US-0026). The main part saves over the open scenario - the
// screen confirms first - or, where the scenario cannot be saved over, saves as a new one, so it
// always does something. The arrow opens a menu with "Save scenario as…".
//
// While `blocked` names why the scenario cannot be saved, neither part saves.
//
// The menu closes on choosing, on Escape and on a click anywhere else.

import { useEffect, useRef, useState } from 'react';

import Icon from '../ui/Icon.jsx';

export default function SaveButton({ canSaveOver, changed, blocked, onSaveOver, onSaveAs }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (event.type === 'keydown' ? event.key === 'Escape' : !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', close);
    };
  }, [open]);

  const saveAs = () => {
    setOpen(false);
    onSaveAs();
  };

  return (
    <div className="split-button" ref={ref}>
      <button type="button" className="primary" title={blocked ?? undefined}
              disabled={Boolean(blocked) || (canSaveOver && !changed)}
              onClick={canSaveOver ? onSaveOver : onSaveAs}>
        Save scenario
      </button>
      <button type="button" className="primary split-button-arrow" aria-label="More save options"
              aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <Icon name="down" />
      </button>
      {open && (
        <ul className="split-button-menu" role="menu">
          <li role="none">
            <button type="button" role="menuitem" onClick={saveAs} disabled={Boolean(blocked)}
                    title={blocked ?? undefined}>
              Save scenario as…
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}
